var _style, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg11SigennEnerugi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#008837;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_px\\u5358\\u4F4D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15,22 7,22 7,16 8,16 10,14 10,10 9,10 9,6 7,6 7,10 5,10 5,6 3,6 3,10 2,10 2,14 4,16 5,16 5,22  5,24 7,24 14,24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "22,9.4 26,2 18,2 14,15 20,15 14,28 28,9.4  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D_1_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_px\\u5358\\u4F4D_1_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11SigennEnerugi);
export default __webpack_public_path__ + "static/media/11_sigenn_enerugi.1f8929647cc64efcca428672a33a8a96.svg";
export { ForwardRef as ReactComponent };